import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/auth.service';
@Injectable({
  providedIn: 'root',
})
export class PortalPermission {
  modulePermissions: Object[] = [];

  constructor(private authService: AuthService) {
    if (!this.authService.user) return;

    this.authService.user.AccessRoles.forEach((item: any) => {
      this.modulePermissions.push({
        ModuleName: item.ModuleName,
        CanView: item.View,
        CanEdit: item.Edit,
        CanAdd: item.Add,
        CanDelete: item.Delete,
      });
    });
  }

  canView(module: string): boolean {
    return (
      this.modulePermissions.filter((item: any) => {
        return item.ModuleName === module && item.CanView === true;
      }).length > 0
    );
  }

  canAdd(module: string): boolean {
    return (
      this.modulePermissions.filter((item: any) => {
        return item.ModuleName === module && item.CanAdd === true;
      }).length > 0
    );
  }

  canEdit(module: string): boolean {
    return (
      this.modulePermissions.filter((item: any) => {
        return item.ModuleName === module && item.CanEdit === true;
      }).length > 0
    );
  }

  canDelete(module: string): boolean {
    return (
      this.modulePermissions.filter((item: any) => {
        return item.ModuleName === module && item.CanDelete === true;
      }).length > 0
    );
  }
}
